// ⬅️ importiere useEffect zusätzlich
import React, { useState, useRef, useEffect } from 'react';

import './App.css';
import Page1 from './components/Page1';
import Page2 from './components/Page2';
import Page3 from './components/Page3';
import ArrowNav from './components/ArrowNav';
import './components/arrow-nav.css';

function App() {
    const [pageIndex, setPageIndex] = useState(0);

    // Viewport-Breite merken
    const [viewportWidth, setViewportWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 1920
    );

    // nur noch für evtl. spätere Logik – wird gesetzt, aber nicht weiter genutzt
    // eslint-disable-next-line no-unused-vars
    const [isNarrow, setIsNarrow] = useState(false);

    const lastTapRef = useRef(0);
    const [showLeftArrow, setShowLeftArrow] = useState(true);
    const [showRightArrow, setShowRightArrow] = useState(false);

    const pages = [<Page1 />, <Page2 />, <Page3 />];
    //const totalPages = pages.length;


    const nextPage = () => setPageIndex((p) => (p + 1) % pages.length);
    const prevPage = () => setPageIndex((p) => (p - 1 + pages.length) % pages.length);

    // ▶️ Smartphone-Kriterium: nur über Breite
    const isMobile = viewportWidth < 768;

    // --- ENV-ERKENNUNG: nur noch Breite -------------------------
    useEffect(() => {
        const updateEnv = () => {
            const w = window.innerWidth;
            setViewportWidth(w);
            setIsNarrow(w < 768);
        };

        updateEnv();
        window.addEventListener('resize', updateEnv);

        return () => {
            window.removeEventListener('resize', updateEnv);
        };
    }, []);
    //useEffect(() => {
    //    const updateBoth = () => {
    //        const sc = getFirstHorizontalScroller();

    //        const isTabletBand = viewportWidth >= 768 && viewportWidth <= 1024;

    //        // 📱 SMARTPHONE (<768)
    //        if (isMobile) {
    //            if (!sc) {
    //                // kein Scroller → nur rechter Pfeil für Seitenwechsel
    //                setShowLeftArrow(false);
    //                setShowRightArrow(true);
    //                return;
    //            }

    //            const max = Math.max(0, sc.scrollWidth - sc.clientWidth);
    //            const atLeft = sc.scrollLeft <= 1;

    //            setShowLeftArrow(!atLeft); // sobald gescrollt wurde
    //            setShowRightArrow(true);   // immer sichtbar
    //            return;
    //        }

    //        // 💊 TABLET-BAND (768–1024): Pfeile immer als Seitennavigation
    //        if (isTabletBand) {
    //            setShowLeftArrow(pageIndex > 0);
    //            setShowRightArrow(pageIndex < totalPages - 1);
    //            return;
    //        }

    //        // 💻 DESKTOP (>1024) – alte Logik
    //        if (!sc) {
    //            // KEIN horizontaler Scroller:
    //            // 👉 Auf Page 2 Pfeile als Seitennavigation zeigen
    //            // 👉 Auf Page 1 & 3 Pfeile ausblenden
    //            if (pageIndex === 1) {
    //                setShowLeftArrow(true);
    //                setShowRightArrow(true);
    //            } else {
    //                setShowLeftArrow(false);
    //                setShowRightArrow(false);
    //            }
    //            return;
    //        }

    //        // MIT Scroller: Pfeile abhängig von Scrollposition
    //        const max = Math.max(0, sc.scrollWidth - sc.clientWidth);
    //        const atLeft = sc.scrollLeft <= 1;
    //        const atRight = sc.scrollLeft >= max - 1;
    //        setShowLeftArrow(!atLeft);
    //        setShowRightArrow(!atRight);
    //    };

    //    updateBoth();
    //    const sc = getFirstHorizontalScroller();
    //    const onScroll = () => updateBoth();
    //    const onResize = () => updateBoth();

    //    if (sc) sc.addEventListener("scroll", onScroll, { passive: true });
    //    window.addEventListener("resize", onResize);

    //    const poll = setInterval(updateBoth, 250);
    //    const stop = setTimeout(() => clearInterval(poll), 3000);

    //    return () => {
    //        if (sc) sc.removeEventListener("scroll", onScroll);
    //        window.removeEventListener("resize", onResize);
    //        clearInterval(poll);
    //        clearTimeout(stop);
    //    };
    //}, [pageIndex, isMobile, viewportWidth, totalPages]);

    // Prüfen, ob das Event in einem Element mit horizontalem Scrollen stattfindet
    const isInsideHorizontalScroller = (el) => {
        let node = el;
        while (node && node !== document.body) {
            if (node instanceof HTMLElement) {
                const style = getComputedStyle(node);
                const ox = style.overflowX;
                if (ox === 'auto' || ox === 'scroll') {
                    return true;
                }
            }
            node = node.parentElement;
        }
        return false;
    };
    const handlePointerUp = (e) => {
        // Klicks auf Links/Buttons/Arrows ignorieren
        if (e.target.closest('a, button, .arrow-btn')) return;

        const pointerType = e.pointerType || 'mouse'; // Fallback

        // 🖱 nur Linksklick soll einen Seitenwechsel auslösen
        if ((pointerType === 'mouse' || pointerType === 'pen') && e.button !== 0) {
            // Rechtsklick oder Mittelklick → nichts tun
            return;
        }

        // 📱 TOUCH
        if (pointerType === 'touch') {
            // Smartphone vs. Tablet unterscheiden
            // isMobile = viewportWidth < 768 (kommt aus deinem State)
            if (!isMobile) {
                // 👉 Tablet mit Touch:
                //    KEIN Seitenwechsel über Tippen, nur über Arrows
                return;
            }

            // 👉 Smartphone mit Touch:
            //    Doppeltipp zum Blättern wie bisher
            const now = Date.now();
            if (now - lastTapRef.current < 300) {
                lastTapRef.current = 0;
                nextPage();
            } else {
                lastTapRef.current = now;
            }
            return;
        }

        // 💻 Maus / Pen:
        if (pointerType === 'mouse' || pointerType === 'pen') {
            // Scrollbar-Klicks auf Page 2 unterdrücken
            const isScrollbarClick =
                pageIndex === 1 &&                       // nur auf Page2 relevant
                isInsideHorizontalScroller(e.target) && // in einem horizontalen Scroller
                e.clientY >= window.innerHeight - 24;   // sehr weit unten (Scrollbar-Zone)

            if (isScrollbarClick) {
                // nichts tun → kein Seitenwechsel
                return;
            }

            // normal weiterblättern
            nextPage();
        }
    };

    // Version: Tablet mit Touch blätter nur mit doppel Tapping-Korrekter-9.12.25
    //const handlePointerUp = (e) => {
    //    // Klicks auf Links/Buttons/Arrows ignorieren
    //    if (e.target.closest('a, button, .arrow-btn')) return;

    //    const pointerType = e.pointerType || 'mouse'; // Fallback

    //    // 🖱 NEU: nur Linksklick soll einen Seitenwechsel auslösen
    //    if ((pointerType === 'mouse' || pointerType === 'pen') && e.button !== 0) {
    //        // Rechtsklick oder Mittelklick → nichts tun
    //        return;
    //    }

    //    if (pointerType === 'mouse' || pointerType === 'pen') {
    //        // 👉 Scrollbar-Klicks auf Page 2 unterdrücken
    //        const isScrollbarClick =
    //            pageIndex === 1 &&                       // nur auf Page2 relevant
    //            isInsideHorizontalScroller(e.target) && // in einem horizontalen Scroller
    //            e.clientY >= window.innerHeight - 24;   // sehr weit unten (Scrollbar-Zone)

    //        if (isScrollbarClick) {
    //            // nichts tun → kein Seitenwechsel
    //            return;
    //        }

    //        // 💻 Maus / Stift → normal weiterblättern
    //        nextPage();
    //        return;
    //    }

    //    if (pointerType === 'touch') {
    //        // 📱 Touch → Doppeltipp-Logik wie bisher
    //        const now = Date.now();
    //        if (now - lastTapRef.current < 300) {
    //            lastTapRef.current = 0;
    //            nextPage();
    //        } else {
    //            lastTapRef.current = now;
    //        }
    //    }
    //};


    // --- Horizontal-Scroller finden ---
    const getFirstHorizontalScroller = () => {
        const root = document.querySelector('.app-container');
        if (!root) return null;
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
        const candidates = [];
        for (let n = walker.currentNode; n; n = walker.nextNode()) {
            const el = /** @type {HTMLElement} */ (n);
            const ox = getComputedStyle(el).overflowX;
            if (ox === 'auto' || ox === 'scroll') candidates.push(el);
        }
        if (!candidates.length) return null;
        candidates.sort((a, b) => (b.scrollWidth || 0) - (a.scrollWidth || 0));
        return candidates[0];
    };

    // --- Pfeile: ZURÜCK ---
    //const handleArrowPrev = () => {
    //    const scroller = getFirstHorizontalScroller();

    //    // 📱 Smartphone: nur scrollen, NIE Seitenwechsel
    //    if (isMobile) {
    //        if (scroller) {
    //            scroller.scrollBy({
    //                left: -window.innerWidth * 0.7,
    //                behavior: 'smooth',
    //            });
    //        }
    //        return;
    //    }

    //    // 💻 / Tablet – altes Verhalten
    //    if (!scroller) {
    //        // KEIN Scroller:
    //        // 👉 Nur auf Page 2 Seitenwechsel, sonst nichts tun
    //        if (pageIndex === 1) {
    //            prevPage();
    //        }
    //        return;
    //    }

    //    // Mit Scroller: horizontal scrollen
    //    scroller.scrollBy({ left: -window.innerWidth * 0.7, behavior: 'smooth' });
    //    setShowRightArrow(true);
    //};
    const handleArrowPrev = () => {
        const scroller = getFirstHorizontalScroller();

        // 📱 Smartphone: nur scrollen, NIE Seitenwechsel
        if (isMobile) {
            if (scroller) {
                scroller.scrollBy({
                    left: -window.innerWidth * 0.7,
                    behavior: 'smooth',
                });
            }
            return;
        }

        // 💻 / Tablet ohne Scroller → normal eine Seite zurück
        if (!scroller) {
            if (pageIndex > 0) {
                prevPage();
            }
            return;
        }

        // Mit Scroller: horizontal scrollen
        scroller.scrollBy({
            left: -window.innerWidth * 0.7,
            behavior: 'smooth',
        });
        setShowRightArrow(true);
    };

    // --- Pfeile: VOR ---
    const handleArrowNext = () => {
        const scroller = getFirstHorizontalScroller();

        // Tablet-Bereich: 768–1024 px
        const isTabletBand = viewportWidth >= 768 && viewportWidth <= 1024;
        const isPage2Tablet = isTabletBand && pageIndex === 1;

        // 📱 Smartphone-Logik
        if (isMobile) {
            // Wenn es keinen horizontalen Scroller gibt → direkt nächste Seite
            if (!scroller) {
                nextPage();
                return;
            }

            const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
            const remaining = max - scroller.scrollLeft;

            if (remaining <= 2) {
                // rechter Rand erreicht → Seitenwechsel
                nextPage();
            } else {
                // noch nicht am Rand → erst weiter scrollen
                scroller.scrollBy({
                    left: window.innerWidth * 0.7,
                    behavior: 'smooth',
                });
            }
            return;
        }

        // 💻 / Tablet – ursprüngliche Logik
        // ❗ Fall 1: Kein horizontaler Scroller gefunden
        if (!scroller) {
            // Auf Page2 im Tablet-Band: NICHT die Seite wechseln
            if (!isPage2Tablet) {
                nextPage();
            }
            return;
        }

        // ❗ Fall 2: Page2 + Tablet → Pfeile dürfen NUR scrollen, nie Seite wechseln
        if (isPage2Tablet) {
            scroller.scrollBy({
                left: window.innerWidth * 0.7,
                behavior: 'smooth',
            });
            return;
        }

        // ❗ Fall 3: Alle anderen Fälle (Page1, Page3, große Desktop)
        const remaining =
            scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft;

        if (remaining < 40) {
            nextPage();
        } else {
            scroller.scrollBy({
                left: window.innerWidth * 0.7,
                behavior: 'smooth',
            });
        }
    };

    // --- Sichtbarkeit Pfeile steuern ---
    //useEffect(() => {
    //    const updateBoth = () => {
    //        const sc = getFirstHorizontalScroller();

    //        // 📱 Smartphone: rechter Pfeil IMMER sichtbar,
    //        // linker Pfeil nur, wenn nicht ganz links
    //        if (isMobile) {
    //            if (!sc) {
    //                // kein Scroller → nur rechter Pfeil für Seitenwechsel
    //                setShowLeftArrow(false);
    //                setShowRightArrow(true);
    //                return;
    //            }

    //            const max = Math.max(0, sc.scrollWidth - sc.clientWidth);
    //            const atLeft = sc.scrollLeft <= 1;

    //            setShowLeftArrow(!atLeft); // sobald gescrollt wurde
    //            setShowRightArrow(true);   // immer sichtbar
    //            return;
    //        }

    //        // 💻 / Tablet – ursprüngliche Logik
    //        if (!sc) {
    //            // KEIN horizontaler Scroller:
    //            // 👉 Auf Page 2 Pfeile als Seitennavigation zeigen
    //            // 👉 Auf Page 1 & 3 Pfeile ausblenden
    //            if (pageIndex === 1) {
    //                setShowLeftArrow(true);
    //                setShowRightArrow(true);
    //            } else {
    //                setShowLeftArrow(false);
    //                setShowRightArrow(false);
    //            }
    //            return;
    //        }

    //        // MIT Scroller: Pfeile abhängig von Scrollposition
    //        const max = Math.max(0, sc.scrollWidth - sc.clientWidth);
    //        const atLeft = sc.scrollLeft <= 1;
    //        const atRight = sc.scrollLeft >= max - 1;
    //        setShowLeftArrow(!atLeft);
    //        setShowRightArrow(!atRight);
    //    };

    //    updateBoth();
    //    const sc = getFirstHorizontalScroller();
    //    const onScroll = () => updateBoth();
    //    const onResize = () => updateBoth();

    //    if (sc) sc.addEventListener('scroll', onScroll, { passive: true });
    //    window.addEventListener('resize', onResize);

    //    const poll = setInterval(updateBoth, 250);
    //    const stop = setTimeout(() => clearInterval(poll), 3000);

    //    return () => {
    //        if (sc) sc.removeEventListener('scroll', onScroll);
    //        window.removeEventListener('resize', onResize);
    //        clearInterval(poll);
    //        clearTimeout(stop);
    //    };
    //}, [pageIndex, isMobile, viewportWidth]);
    useEffect(() => {
        const updateBoth = () => {
            const sc = getFirstHorizontalScroller();

            // 📱 Smartphone: rechter Pfeil IMMER sichtbar,
            // linker Pfeil nur, wenn nicht ganz links
            if (isMobile) {
                if (!sc) {
                    // kein Scroller → nur rechter Pfeil für Seitenwechsel
                    setShowLeftArrow(false);
                    setShowRightArrow(true);
                    return;
                }

                const atLeft = sc.scrollLeft <= 1;

                setShowLeftArrow(!atLeft); // sobald gescrollt wurde
                setShowRightArrow(true);   // immer sichtbar
                return;
            }

            // 💻 / Tablet – ursprüngliche Logik
            if (!sc) {
                // KEIN horizontaler Scroller:
                // 👉 Auf Page 2 Pfeile als Seitennavigation zeigen
                // 👉 Auf Page 1 & 3 Pfeile ausblenden
                //if (pageIndex === 1) {
                //    setShowLeftArrow(true);
                //    setShowRightArrow(true);
                //} else {
                //    setShowLeftArrow(false);
                //    setShowRightArrow(false);
                //}
                if (!sc) {
                    // Index 0..2 (3 Seiten)
                    setShowLeftArrow(pageIndex > 0);
                    setShowRightArrow(pageIndex < 2);
                    return;
                }
                return;
            }

            // MIT Scroller: Pfeile abhängig von Scrollposition
            const max = Math.max(0, sc.scrollWidth - sc.clientWidth);
            const atLeft = sc.scrollLeft <= 1;
            const atRight = sc.scrollLeft >= max - 1;
            setShowLeftArrow(!atLeft);
            setShowRightArrow(!atRight);
        };

        updateBoth();
        const sc = getFirstHorizontalScroller();
        const onScroll = () => updateBoth();
        const onResize = () => updateBoth();

        if (sc) sc.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize);

        const poll = setInterval(updateBoth, 250);
        const stop = setTimeout(() => clearInterval(poll), 3000);

        return () => {
            if (sc) sc.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            clearInterval(poll);
            clearTimeout(stop);
        };
    }, [pageIndex, isMobile, viewportWidth]);
    return (
        <div
            className="app-container"
            onPointerUp={handlePointerUp}  // 👉 EIN gemeinsamer Handler
        >
            {pages[pageIndex]}
            <ArrowNav
                onPrev={handleArrowPrev}
                onNext={handleArrowNext}
                showLeft={showLeftArrow}
                showRight={showRightArrow}
                className="is-visible"
            />
            {/* 🔧 Debug-Overlay – später wieder entfernen */}
            {/*<div*/}
            {/*    style={{*/}
            {/*        position: 'fixed',*/}
            {/*        height: '30px',*/}
            {/*        left: '40%',*/}
            {/*        top: 8,*/}
            {/*        bottom: 8,*/}
            {/*        padding: '4px 6px',*/}
            {/*        borderRadius: 4,*/}
            {/*        background: 'rgb(255, 239, 0)',*/}
            {/*        color: '#000',*/}
            {/*        fontSize: 20,*/}
            {/*        fontFamily: 'monospace',*/}
            {/*        zIndex: 9999,*/}
            {/*    }}*/}
            {/*>*/}
            {/*    {window.innerWidth}×{window.innerHeight}px · DPR {window.devicePixelRatio}*/}
            {/*</div>*/}
        </div>


    );
}

export default App;
